import { Search, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useGetPickupZones } from "@/api/pickupZones.api";
import { SelectV2 } from "@/components/ui/customs/select-v2";
import { UnifiedInput } from "@/components/ui/customs/unified-input";

type CollectionFiltersProps = {
  setSelectedPickupZoneId: React.Dispatch<React.SetStateAction<string | null>>;
  selectedPickupZoneId: string | null;
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
};

export const CollectionFilters = ({
  setSelectedPickupZoneId,
  selectedPickupZoneId,
  search,
  setSearch,
}: CollectionFiltersProps) => {
  const { t } = useTranslation("boLogistics");
  const { data: pickupZones } = useGetPickupZones();

  const closeSearch = () => {
    setSearch("");
  };

  return (
    <div className="z-10 flex w-full flex-wrap items-center gap-2">
      <UnifiedInput
        autoFocus
        inputType="text"
        leftElement={<Search />}
        rightElement={
          <button type="button" onClick={closeSearch} className="text-gray-400 hover:text-gray-600">
            <X className="size-4" />
          </button>
        }
        value={search}
        onChange={(value) => setSearch(String(value ?? ""))}
        placeholder={t("collectionFilters.searchPlaceholder")}
        wrapperClassName="min-w-[300px] w-full sm:w-fit"
      />
      <SelectV2
        placeholder={t("collectionFilters.zonePlaceholder")}
        searchPlaceholder={t("collectionFilters.zoneSearchPlaceholder")}
        clearable
        searchable
        value={selectedPickupZoneId ?? ""}
        options={
          pickupZones?.map((zone) => ({
            value: zone.id,
            label: zone.name,
          })) || []
        }
        onChange={(value) => setSelectedPickupZoneId(value)}
        wrapperClassName="min-w-[300px] w-full sm:w-fit"
      />
    </div>
  );
};
